module.exports = __webpack_public_path__ + "static/media/asciugamani.dd2bbee3.svg";